export const EmptyTileLayer = () => null;
